(
    function (skyward, $, undefined) 
    {
        "use strict";

        skyward.workflowProcess = skyward.workflowProcess || {};

        var waiting = async function (statusData, button, event)
        {
            if (statusData.synchronousLockWaiting)
            {
                var cancelButton = { id: "cancelButton", text: "Cancel", click: "close", icon: "Cancel" };

                if (waitingBox == null) 
                {
                    waitingBox = skyward.modalLayer.showProcessingDialog(
                        "Processing Request",
                        statusData.message,
                        [cancelButton],
                        {
                            closeOnClick: true,
                            closeOnEscape: true,
                            afterClose: function ()
                            {
                                waitingBox = null;
                                nextPopupID = null;

                                $.ajax(skyward.global.virtualDir + "Workflow/SynchronousLock/Clear/" + statusData.synchronousLockID,
                                {
                                    type: "POST",
                                    success: function (data)
                                    {
                                        skyward.window.closePopup();
                                    }
                                });

                                if (requestHandle) 
                                {
                                    clearTimeout(requestHandle);
                                    requestHandle = null;
                                }

                                $(document.body).removeClass("cursor-progress");
                            },
                            width: "550px"
                        });
                }
                else 
                {
                    await waitingBox.content.viewpartHtml(statusData.message);
                }

                requestHandle = setTimeout(function () 
                {
                    runTask(event, button);
                }, 5000);
            }
        }

        var runTask = function (event, button)
        {
            if (button == null || button.data === undefined) 
            {
                button = $(this);
            }

            var id = button.data().processstepinstanceid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/ProcessStepInstance/StartProcessStepInstance/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            displayNextTask(data.taskInstanceID);
                        }
                        else if (data.synchronousLockWaiting) 
                        {
                            waiting(data, button, event);
                        }
                        else 
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start task", data.errorMessage);
                        }                        
                    }
                });

            event.stopPropagation();
        };

        var startProcess = function (event) 
        {
            var button = $(this);

            var id = button.data().processid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/Process/StartProcess/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, endWorkflow, function (data) { displayNextTask(data.taskInstanceId); }, null);
                        }
                        else
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start process", data.errorMessage);
                        }
                    }
                });

            event.stopPropagation();
        };

        var endWorkflow = function () { skyward.workflow.closeWorkflowPopup(); };

        var requestHandle;
        var waitingBox;
        var nextPopupID;

        var displayNextTask = function (taskInstanceID)
        {
            if (nextPopupID == null)
            {
                nextPopupID = "popup" + skyward.window.getNextPopupId();
            }

            return skyward.window.loadContent("popup", "workflow", "taskinstance", "currentinstance", taskInstanceID, undefined, undefined, undefined);
        };

        var events =
        {
            "runTask": runTask,
            "startProcess": startProcess
        };

        skyward.events.registerEvents("workflowprocess", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
